<template>
    <!-- 预约 -->
    <div class="equipDetails">
        <!-- 预约须知弹框 -->
        <el-dialog title="预约须知" :visible.sync="noticeVisible" center id="noticeDialog" :close-on-click-modal="false" :show-close="false" width="650px">
            <div class="testingInstructions">
                <div class="editorContent" v-html="dataForm.testingInstructions"></div>
            </div>
            <span slot="footer">
                <el-button type="primary" style="width: 150px" @click="noticeVisible = false">立即预约</el-button>
            </span>
        </el-dialog>
        <div class="details_content" style="margin-bottom: 80px">
            <div class="details_left">
                <div class="appoint_name">
                    <span style="color: #4d6fff">预约：</span>
                    {{ dataForm.equipmentName }}
                </div>
                <div v-if="currentIndex == 1">
                    <!-- 预约详情 -->
                    <el-card class="details_box-card" shadow="never">
                        <div slot="header" class="clearfix">
                            <div class="descicon"></div>
                            预约须知
                            <div class="isShow">
                                <div v-if="isShow" @click="tabIsShow()">
                                    <i class="el-icon-arrow-up"></i>
                                </div>
                                <div v-if="!isShow" @click="tabIsShow()">
                                    <i class="el-icon-arrow-down"></i>
                                </div>
                            </div>
                        </div>
                        <div v-if="isShow">
                            <div class="editorContent" v-html="dataForm.testingInstructions"></div>
                        </div>
                    </el-card>
                    <!-- 预约表单 -->
                    <detectionOrder ref="detectionOrder" :baseFieldValuesNull="baseFieldValuesNull" @updateDetectionTotal="updateDetectionForm" @updateBaseFieldValuesNull="updateBaseFieldValuesNull" @updateDesc="updateDesc"></detectionOrder>
                    <el-form @submit.native.prevent ref="form" :model="form" label-width="200px" label-position="left" style="width: 80%">
                        <el-card class="details_box-card" shadow="never">
                            <div style="width: 80%">
                                <el-form-item label="实验留言" prop="message">
                                    <el-input v-model="form.message" type="textarea" maxlength="200" show-word-limit :rows="4" placeholder="请输入留言"></el-input>
                                </el-form-item>
                                <el-form-item label="订单备注" prop="customRemark">
                                    <el-input v-model="form.customRemark" type="textarea" maxlength="200" show-word-limit :rows="4" placeholder="请输入订单备注(可输入结算项目名称)"></el-input>
                                </el-form-item>
                                <el-form-item label="附件" prop="fileList">
                                    <uploadText :fileList="form.fileList" ref="getfile" @getFile="getFile"></uploadText>
                                </el-form-item>
                            </div>
                        </el-card>
                    </el-form>
                </div>
                <!-- 邮寄地址 -->
                <mail v-show="currentIndex == 2" ref="mail" :isTeamShop="isTeamShop" :equipmentInfo="dataForm" @getMailInfo="getMailInfo"></mail>
                <!-- 支付详情 -->
                <payPage v-show="currentIndex == 3" ref="pay" :isTeamShop="isTeamShop" @getTotalCost="getTotalCost"></payPage>
                <!-- 微信支付弹窗 -->
                <we-chat-pay @creatOrder="creatOrder" @closeWxPay="closeWxPay" :wxPayInfo="wxPayInfo" v-if="weChatPayStatus"></we-chat-pay>
                <!-- 支付宝支付弹窗 -->
                <alipay @creatALiPayOrder="creatALiPayOrder" @closeALiPayOrder="closeALiPayOrder" v-if="aliPayStatus" ref="alipay" :aliPayOrder="aliPayOrder"></alipay>
                <!-- 底部合计 -->
                <div class="buffet-total-box" :style="{ bottom: positionBottom }">
                    <div class="buffet-total">
                        <div class="clearfloat">
                            <el-popover placement="top-start" width="500" trigger="hover">
                                <buffetList :buffetList="buffetList" :dataForm="dataForm" :showBargaining="showBargaining"></buffetList>
                                <div class="b_price_detail fl" slot="reference">
                                    <span v-if="showBargaining && showBargaining.length == 0">
                                        合计费用
                                        <span class="redColor" style="font-size: 30px; padding-left: 20px">¥{{ form.totalCost }}</span>
                                    </span>
                                    <span class="orangeColor" v-if="showBargaining && showBargaining.length > 0">{{ showBargaining[0] }}</span>
                                    <span class="showDetail">
                                        费用明细
                                        <span class="detail_icon">
                                            <i class="el-icon-arrow-up"></i>
                                        </span>
                                    </span>
                                </div>
                            </el-popover>
                            <div></div>
                            <div style="display: flex; column-gap: 10px; align-items: center;">
                                <el-button type="primary" :loading="loading_draft" @click="addDrafts()">存为草稿</el-button>
                                <div class="fr" v-if="showBargaining.length == 0">
                                    <el-button type="primary" style="width: 100px; margin-right: 20px" v-if="currentIndex == 2" @click="lastHandle()">上一步</el-button>
                                    <el-button type="primary" style="width: 100px; margin-right: 20px" v-if="currentIndex != 3" @click="nextHandle()">
                                        {{ currentIndex == 1 ? '下一步' : '确认预约' }}
                                    </el-button>
                                    <el-button type="primary" style="margin-right: 20px; padding: 12px 24px;" :loading="loading_submit" v-else @click="submitHandle()">确认支付</el-button>
                                </div>
                                <!-- 待议价情况邮寄页面提交直接预约成功 -->
                                <div class="fr" v-if="showBargaining.length > 0">
                                    <el-button type="primary" style="width: 100px; margin-right: 20px" v-if="currentIndex == 2" @click="lastHandle()">上一步</el-button>
                                    <el-button type="primary" style="width: 100px; margin-right: 20px" v-if="currentIndex == 1" @click="nextHandle()">下一步</el-button>
                                    <el-button type="primary" style="margin-right: 20px; padding: 12px 24px;" :loading="loading_submit" v-else @click="submitHandle()">确认预约</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="details_right">
                <div v-if="currentIndex == 1">
                    <div class="descicon"></div>
                    <span class="right_title">仪器图片</span>
                    <div class="details_img_box">
                        <el-image :src="dataForm.fileList && dataForm.fileList.length > 0 ? imgurl + dataForm.fileList[0].url : '../../assets/img/morentupian.png'" class="right_details_img">
                            <div slot="error">
                                <img class="right_details_img" src="../../assets/img/morentupian.png" />
                            </div>
                        </el-image>
                        <el-button type="primary" class="clickLook" style="margin-bottom: 30px" size="small" @click="detailsHandle()">查看仪器详情</el-button>
                    </div>
                </div>
                <div class="descicon"></div>
                <span class="right_title">技术顾问</span>
                <div class="technical">
                    <el-image :src="serviceQRCode ? serviceQRCode : '../../assets/img/morentupian.png'" class="lxfs">
                        <div slot="error">
                            <img class="lxfs" src="../../assets/img/morentupian.png" />
                        </div>
                    </el-image>
                    <br />
                    {{ dataForm.technicalAdvisorTextPrompts || '暂无提示文字' }}
                </div>
            </div>
        </div>
        <!-- 预约成功弹框 -->
        <appointSuccess ref="appointStatus" :form="form" v-if="appointSuccessVisible"></appointSuccess>
    </div>
</template>
<script>
import mail from './mail'
import { equipInfo, equipmentSubscribeAdd, createWXOrder, ZFBPreorderAction, getActives, addSubscribeDrafts, checkPayStatus } from '@/api/request'
import { requiredVerification } from './baseUtils'
import uploadText from '../common/uploadText'
import detectionOrder from './detectionOrder'
import payPage from './payPage'
import buffetList from './buffetList'
import appointSuccess from './appointSuccess'
import weChatPay from './WeChatPayPop.vue'
import { getClient } from '@/plugins/auth'
import Alipay from './Alipay.vue'
import mittBus from '@/utils/mittBus'

export default {
    components: { mail, detectionOrder, payPage, buffetList, appointSuccess, weChatPay, Alipay, uploadText },
    data() {
        return {
            isTeamShop: false,//是否为团购设备
            imgurl: process.env.VUE_APP_FILE_API,
            serviceQRCode: localStorage.getItem('serviceQRCode'),
            noticeVisible: false,
            id: null,
            appointSuccessVisible: false,
            currentIndex: 1,
            isShow: true,
            show_cashBack_tips: false,//是否提示可参与下单返现活动
            baseFieldValuesNull: false,//基础字段---   样品数量   样品编号   样品成分   能否为空
            showDetail: true,
            loading_submit: false,
            loading_draft: false,
            mailValid: false,
            dataForm: {},
            backupsInfo: {}, //预约字段备份，处理上一步
            appointForm: {}, //预约字段信息
            mailInfo: {}, //邮寄信息
            userInfo: JSON.parse(getClient()),
            showBargaining: [], //议价字段存储
            weChatPayStatus: false, //微信支付弹窗状态
            aliPayStatus: false, // 支付宝支付状态
            wxPayInfo: null, //微信支付信息
            aliPayOrder: null, //支付宝支付信息
            isAddOrder: false,
            form: {
                photographyMethod: 1,
                isMagnetism: 0,
                appointmentStartDate: '',
                appointmentEndDate: '',
                originalPrice: '0.00',
                message: '',
                customRemark: '',
                fieIdList: [],
                totalCost: 0,
            },
            mailBuffet: {
                sampleName: '实验需求',
                totalPrice: '',
                subChargeVOList: [
                    {
                        buffName: '加急制作',
                        buffValue: '否',
                        totalPrice: 0
                    },
                    {
                        buffName: '是否回收',
                        buffValue: '否',
                        totalPrice: 0
                    },
                    {
                        buffName: '运费支付',
                        buffValue: '运费到付',
                        totalPrice: 12
                    }
                ]
            },
            orderBuffet: {
                sampleName: '优惠费用',
                totalPrice: '',
                sumText: '',
                subChargeVOList: [
                    {
                        buffName: '个人折扣',
                        buffValue: '100%',
                        totalPrice: '100%'
                    },
                    {
                        buffName: '优惠券',
                        buffValue: '0',
                        totalPrice: 0
                    },
                    {
                        buffName: '赠送金',
                        buffValue: '0',
                        totalPrice: 0
                    }
                ]
            },
            activeWayIndex: 1,
            positionBottom: '0px',
            wayoptions: [
                { optionName: '云现场', index: 1 },
                { optionName: '现场', index: 2 }
            ],
            MagnetismOption: [
                { optionName: '没有磁性', index: 0 },
                { optionName: '有磁性', index: 1 }
            ],
            timeTips:
                '每半小时为预约节点，1h起约，最后测试费用根据实际时长折算收费，多退少补！根据测试要求和样品情况，平均1小时拍4个样品左右，请务必预约充足的测试时间，合理安排测试内容，尽量做到到点就结束测试。',
            buffetList: []
        }
    },
    watch: {
        currentIndex(newValue) {
            if(newValue == 2) {
                this.$refs.mail.backInfo()
            } 
        }
    },
    created() {
        this.getInfo()
        getActives(2).then(res => {
            if(res.data) {
                this.show_cashBack_tips = res.data.activityStatusEnum == 2 ? true : false
            } else {
                this.show_cashBack_tips = false
            }
        })
    },
    mounted() {
        this.id = this.$route.query.id
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, true)
    },
    methods: {
        async getInfo() {
            const res = await equipInfo(this.$route.query.id)
            this.isTeamShop = Boolean(res.data.isGroupBuy)
            this.dataForm = res.data
            if(this.$route.query.mode == 'againOrder' || this.$route.query.mode == 'draftsOrder') {
                await this.$refs.detectionOrder.init('copy')
            } else {
                await this.$refs.detectionOrder.init('add')
            }
            this.$nextTick(() => {
                if(this.dataForm.testingInstructions && this.userInfo.certStatus != 1) {
                    this.$confirm('您还未进行身份认证，是否前往个人中心进行身份认证?', '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({
                            path: "/aboutUsIndex",
                            query: {
                                tabIndex: '1-2', 
                            },
                        })
                    }).catch(() => {
                        this.noticeVisible = true
                        window.addEventListener('scroll', this.handleScroll, true)
                    })
                } else {
                    this.noticeVisible = true
                    window.addEventListener('scroll', this.handleScroll, true)
                }
            })
        },
        getFile(file) {
            this.form.fileList = file
        },
        tabIsShow() {
            this.isShow = !this.isShow
            this.$forceUpdate()
        },
        //获取待支付页面信息
        getTotalCost(info) {
            this.form.discountType = ''
            this.form.discountMoney = 0
            this.form.couponMoney = 0
            this.form.cashCoupon = 0
            this.form = { ...this.form, ...info }
            this.orderBuffet.sumText = ''
            if (this.form.discountType == 1) {
                this.orderBuffet.subChargeVOList[0].buffName = '个人折扣'
                this.orderBuffet.subChargeVOList[0].buffValue = this.userInfo.discountRate + '%'
                this.orderBuffet.subChargeVOList[0].totalPrice = `-￥${this.form.originalPrice * ((100 - this.userInfo.discountRate) / 100)}`
                this.orderBuffet.sumText = this.orderBuffet.sumText + this.form.originalPrice + '*' + this.userInfo.discountRate + '%'
            } else if(this.appointForm.discountType == 2) {
                this.orderBuffet.subChargeVOList[0].buffName = '团队折扣'
                this.orderBuffet.subChargeVOList[0].buffValue = this.userInfo.discountRateTeam + '%'
                this.orderBuffet.subChargeVOList[0].totalPrice = `-￥${this.form.originalPrice * ((100 - this.userInfo.discountRateTeam) / 100)}`
                this.orderBuffet.sumText = this.orderBuffet.sumText + this.form.originalPrice + '*' + this.userInfo.discountRateTeam + '%'
            } else {
                this.orderBuffet.subChargeVOList[0].buffName = '暂无折扣'
                this.orderBuffet.subChargeVOList[0].buffValue = ''
                this.orderBuffet.subChargeVOList[0].totalPrice = '暂无折扣'
                this.orderBuffet.sumText = this.orderBuffet.sumText + this.form.originalPrice
            }
            if (this.form.ifUrgent === 1) {
                this.orderBuffet.sumText = this.orderBuffet.sumText + '+' + this.form.originalPrice * 0.5
            }
            if (this.form.ifRecycle === 1) {
                if (this.userInfo.whiteFlag !== 1 && this.userInfo.recoveryFree !== 1) {
                    this.orderBuffet.sumText = this.orderBuffet.sumText + '+50'
                }
            }
            if (this.form.postMethod == 1) {
                if (this.form.postPayment === 2) {
                } else {
                    this.orderBuffet.sumText = this.orderBuffet.sumText + '+12'
                }
            }
            if (this.form.couponMoney >= 0) {
                this.orderBuffet.subChargeVOList[1].buffValue = `￥${this.form.couponMoney}`
                this.orderBuffet.subChargeVOList[1].totalPrice = `- ￥${this.form.couponMoney}`
                this.orderBuffet.sumText = this.orderBuffet.sumText + '-' + this.form.couponMoney
            }
            if (this.form.cashCoupon >= 0) {
                this.orderBuffet.subChargeVOList[2].buffValue = `￥${this.form.cashCoupon}`
                this.orderBuffet.subChargeVOList[2].totalPrice = `- ￥${this.form.cashCoupon}`
                this.orderBuffet.sumText = this.orderBuffet.sumText + '-' + this.form.cashCoupon
            }

            this.orderBuffet.totalPrice = this.form.totalCost
            const hasOrderDiscount = this.form.expenseDetailList.some((item) => item.sampleName.includes('优惠费用'))
            if (hasOrderDiscount) {
                this.form.expenseDetailList[this.form.expenseDetailList.length - 1] = this.orderBuffet
            } else {
                this.form.expenseDetailList.push(this.orderBuffet)
            }
            this.buffetList = this.form.expenseDetailList
            this.$forceUpdate()
        },
        async submitHandle() {
            let waitPay = true
            let obj = {}
            if (this.showBargaining.length == 0) {
                if (!this.form.prepaidPayment || this.form.prepaidPayment == '') {
                    return this.$message.warning('请选择支付方式')
                }
                obj = { ...this.form, status: 2 }
            } else {
                this.$refs.mail.backInfo()
                if (!this.mailValid) {
                    return this.$message.error('有必填项（带*为必填项）未完成填写或未规范填写，请规范填写所有必填项')
                }
                obj = {
                    ...this.form,
                    ...this.appointForm,
                    ...this.mailInfo,
                    orderType: this.dataForm.isCloudScene,
                    equipmentId: this.dataForm.id,
                    expenseDetailList: this.buffetList,
                    status: 1
                }
            }
            this.loading_submit = true
            //校验订单支付状态 有subscribeId为正常下单，没有的为待议价订单，无需校验
            if(obj.subscribeId) {
                const res = await checkPayStatus(obj.subscribeId)
                waitPay = res.data.status == 1
            }
            if(!waitPay) {
                this.$alert('该订单状态已发生改变！', '温馨提示', {
                    confirmButtonText: '确定',
                    showClose: false,
                    callback: () => {
                        this.$router.push('/')
                    }
                })
            } else {
                //现金支付 0 元订单直接创建订单
                if (this.showBargaining.length == 0 && Number(obj.totalCost) === 0 && (this.form.prepaidPayment == 3 || this.form.prepaidPayment == 4)) {
                    equipmentSubscribeAdd(obj).then((res) => {
                        this.appointSuccessVisible = true
                        this.$nextTick(() => {
                            this.$refs.appointStatus.init()
                            this.$message({
                                type: 'success',
                                message: '下单成功！'
                            })
                        })
                    }).finally(() => {
                        this.loading_submit = false
                    })
                    return
                }
                //现金支付 非0元 弹出支付弹框
                if (this.form.prepaidPayment == 4) {
                    let orderInfo = {
                        subscribeId: this.form.subscribeId,
                        totalPrice: this.form.totalCost * 100, //后端金额单位为分 需要乘以100换算为分
                        goodsName: this.dataForm.equipmentName, //商品描述 取得设备名称
                        notifyUrl: process.env.VUE_APP_PAY_API //回调地址 通知url必须为外网可访问的url，不能携带参数。 公网域名必须为https，如果是走专线接入，使用专线NAT IP或者私有回调域名可使用http
                    }
                    createWXOrder(orderInfo)
                        .then((res) => {
                            this.wxPayInfo = res.data
                            this.wxPayInfo.totalCost = this.form.totalCost
                            this.wxPayInfo.subscribeId = this.form.subscribeId
                            this.weChatPayStatus = true
                        })
                } else if (this.form.prepaidPayment == 3) {
                    let orderInfo = {
                        subscribeId: this.form.subscribeId,
                        price: this.form.totalCost, //单位是元
                        goodsName: this.dataForm.equipmentName, //商品描述 取得设备名称
                        notifyUrl: process.env.VUE_APP_PAY_API //回调地址 通知url必须为外网可访问的url，不能携带参数。 公网域名必须为https，如果是走专线接入，使用专线NAT IP或者私有回调域名可使用http
                    }
                    ZFBPreorderAction(orderInfo)
                        .then((res) => {
                            this.aliPayOrder = {
                                barcodeText: res.data.body,
                                orderCode: res.data.orderCode,
                                subscribeId: this.form.subscribeId,
                                price: this.form.totalCost,
                                goodsName: this.dataForm.equipmentName
                            }
                            this.aliPayStatus = true
                            this.$nextTick(() => {
                                this.$refs.alipay.init(this.aliPayOrder)
                            })
                        })
                } else {
                    this.$confirm('是否确认支付订单？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'success',
                        closeOnClickModal: false,
                    }).then(() => {
                        // 其他的直接提交
                        equipmentSubscribeAdd(obj).then((res) => {
                            this.appointSuccessVisible = true
                            this.$nextTick(() => {
                                this.$refs.appointStatus.init()
                                this.$message({
                                    type: 'success',
                                    message: '下单成功！'
                                })
                            })
                        }).finally(() => {
                            this.loading_submit = false
                        })
                    }).catch(() => {
                        this.$message({type: 'warning', message: '已取消支付'})
                        this.loading_submit = false
                    })
                }
            }
        },
        //关闭微信支付弹窗
        closeWxPay(e) {
            this.wxPayInfo = null
            this.weChatPayStatus = false
            if (e) {
                this.$router.push({
                    path: '/aboutUsIndex',
                    query: { 
                        type: 13, 
                        tabIndex: '2-1', 
                        tabName: '我的订单' 
                    }
                })
            }
            this.loading_submit = false
        },
        //微信支付成功 创建预约订单
        creatOrder() {
            this.wxPayInfo = null
            this.weChatPayStatus = false
            let obj = { ...this.form, status: 2 }
            // 其他的直接提交
            equipmentSubscribeAdd(obj).then((res) => {
                this.appointSuccessVisible = true
                this.$nextTick(() => {
                    this.$refs.appointStatus.init()
                })
            }).finally(() => {
                this.loading_submit = false
            })
        },
        //关闭支付宝支付订单
        closeALiPayOrder(e) {
            this.aliPayOrder = null
            this.aliPayStatus = false
            if (e) {
                this.$router.push({
                    path: '/aboutUsIndex',
                    query: { 
                        type: 13, 
                        tabIndex: '2-1', 
                        tabName: '我的订单' 
                    }
                })
            }
            this.loading_submit = false
        },
        //支付宝支付完成创建预约订单
        creatALiPayOrder() {
            this.aliPayOrder = null
            this.aliPayStatus = false
            let obj = { ...this.form, status: 2 }
            // 其他的直接提交
            equipmentSubscribeAdd(obj).then((res) => {
                this.appointSuccessVisible = true
                this.$nextTick(() => {
                    this.$refs.appointStatus.init()
                })
            }).finally(() => {
                this.loading_submit = false
            })
        },
        //订单更新数据
        updateDetectionForm(obj) {
            this.backupsInfo = { ...obj }
            this.buffetList = obj.buffetList
            this.form.originalPrice = obj.totalMoney
            this.appointForm.groups = obj.groups
            this.appointForm.globalFieldValues = obj.globalFieldValues
            this.showBargaining = obj.bargainReminder
            this.form.totalCost = obj.totalMoney
            // if(obj.bargainReminder.length >)
            // if(obj.bargainReminder){
            //   // this.bargainReminder
            //   let data = {
            //     bargainReminder: obj.bargainReminder
            //   }
            //   this.showBargaining.push(data)
            // }
        },
        // 存草稿箱
		addDrafts() {
			const orderInfo = JSON.parse(JSON.stringify(this.backupsInfo))
			const obj = {
				groups: [],
				globalFieldValues: orderInfo.globalFieldValues[0].fieIdList,
                message: this.form.message,
                customRemark: this.form.customRemark,
			}
			obj.groups = orderInfo.groups.map(item => {
				const fieIdValue_list = []
				item.fieIdList.forEach(item_ => {
					if(item_.fieIdValue) {
						fieIdValue_list.push(item_)
					}
				})
				const item_new = {
					values: fieIdValue_list,
					sampleName: item.sampleName,
					specimenCode: item.specimenCode,
					specimenCode_string: item.specimenCode_string,
					specimenIngredient: item.specimenIngredient,
					specimenNum: item.specimenNum,
				}
				return item_new
			})
			const data = {
				clientId: this.userInfo.clientId,
				draftsJson: JSON.stringify(obj),
				equipmentId: this.dataForm.id,
				orderId: null,
				subscriberld: null,
				type: 1, //1预约前   2预约后
			}
            this.$confirm("是否将当前数据存入草稿箱？", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(async () => {
              await addSubscribeDrafts(data)
              this.$message.success('存入草稿箱成功！可前往【订单管理】——【草稿箱】查看')
            })
		},
        // 上一步
        lastHandle() {
            this.currentIndex = 1
            //要做编辑赋值处理
            this.$nextTick(() => {
                this.$refs.detectionOrder.init('edit', this.backupsInfo)
                this.$refs.getfile.fileList = this.form.fileList
            })
        },
        nextHandle() {
            if (this.currentIndex == 1) {
                this.$refs.detectionOrder.getOrderFile()
                this.$refs.getfile.getFile()
                this.appointForm = { ...this.appointForm, messsage: this.form.messsage, customRemark: this.form.customRemark, fileList: this.form.fileList }
                //预约表单组-必填校验
                if(!this.baseFieldValuesNull) {
                    //和动态字段必填提示统一
                    let validList = this.appointForm.groups.filter((i) => i.specimenNum == '' || i.specimenNum === undefined)
                    let validList1 = this.appointForm.groups.filter((i) => {
                        if(i.specimenCode_list && i.specimenCode_list.length) {
                            const flag = i.specimenCode_list.some(item => Boolean(item.value) == false)
                            if(flag) return i
                        } else {
                            return i
                        }
                    })
                    let validList2 = this.appointForm.groups.filter((i) => i.specimenIngredient == '')
                    this.appointForm.groups.forEach(item => {
                        item.validate_specimenNum = item.specimenNum ? false : true
                        item.validate_specimenCode = item.specimenCode_list ? item.specimenCode_list.some(item => Boolean(item.value) == false) : false
                        item.validate_specimenIngredient = item.specimenIngredient ? false : true
                    })
                    if (validList.length > 0) {
                        return this.$message.error(validList[0].sampleName + '组样品-样品数量不能为空')
                    }
                    if (validList1.length > 0) {
                        return this.$message.error(validList1[0].sampleName + '组样品-样品编号不能为空')
                    }
                    if (validList2.length > 0) {
                        return this.$message.error(validList2[0].sampleName + '组样品-样品成分不能为空')
                    }
                }
                const buffetList = JSON.parse(JSON.stringify(this.buffetList))
                const result = requiredVerification(buffetList)
                result.resultList.forEach((item, index) => {
                    item.forEach(i => {
                        if(index == 0) {
                            const global_index = this.appointForm.globalFieldValues[index].fieIdList.findIndex(list_item => list_item.fieIdId == i.fieIdId)
                            if(i.fieIdType == 6) {
                                this.appointForm.globalFieldValues[index].fieIdList[global_index].validate = i.fieIdValue == undefined || i.fieIdValue == null
						    } else if(i.fieIdType == 9) {
                                this.appointForm.globalFieldValues[index].fieIdList[global_index].validate = i.fieIdValue == undefined || i.fieIdValue == null || i.fieldValueRange == undefined || i.fieldValueRange == null || (i.fieIdValue == i.fieldValueRange)
                            } else if(i.fieIdType == 12) {
                                mittBus.emit('validateFieldGroups', i)
                            } else {
                                this.appointForm.globalFieldValues[index].fieIdList[global_index].validate = !i.fieIdValue
                            }
                        } else {
                            const group_index = this.appointForm.groups[index - 1].fieIdList.findIndex(list_item => list_item.fieIdId == i.fieIdId)
                            if(i.fieIdType == 6) {
                                this.appointForm.groups[index - 1].fieIdList[group_index].validate = i.fieIdValue == undefined || i.fieIdValue == null
						    } else if(i.fieIdType == 9) {
                                this.appointForm.groups[index - 1].fieIdList[group_index].validate = i.fieIdValue == undefined || i.fieIdValue == null || i.fieldValueRange == undefined || i.fieldValueRange == null || (i.fieIdValue == i.fieldValueRange)
                            } else if(i.fieIdType == 12) {
                                mittBus.emit('validateFieldGroups', i)
                            } else {
                                this.appointForm.groups[index - 1].fieIdList[group_index].validate = !i.fieIdValue
                            }
                        }
                    })
                })
                if (!result.pass) {
                    return this.$message.error(result.messsage)
                } else {
                    this.appointForm.groups.map((i) => {
                        i.fieIdList.map((j) => {
                            if(j.fieIdValue === 0){
                                j.fieIdValue = '0'
                            }else{
                                j.fieIdValue = j.fieIdValue ? j.fieIdValue.toString() : ''
                            }
                            j.valueId = j.valueId ? j.valueId.toString() : ''
                        })
                        let list = i.fieIdList.filter((x) => x.hide == false)
                        i.values = list
                    })
                    this.appointForm.globalFieldValues.map((i) => {
                        i.fieIdList.map((j) => {
                            if(j.fieIdValue === 0){
                                j.fieIdValue = '0'
                            }else{
                                j.fieIdValue = j.fieIdValue ? j.fieIdValue.toString() : ''
                            }
                            j.valueId = j.valueId ? j.valueId.toString() : ''
                        })
                        i.values = i.fieIdList
                    })
                    if (this.appointForm.globalFieldValues && this.appointForm.globalFieldValues.length > 0) {
                        this.appointForm.globalFieldValues[0].fieIdList = this.appointForm.globalFieldValues[0].fieIdList.filter((item) => item.hide == false)
                        this.appointForm.globalFieldValues = this.appointForm.globalFieldValues[0].fieIdList
                    }
                    //费用明细
                    this.buffetList.map((i) => {
                        i.subChargeVOList.map((j) => {
                            j.quantity = i.specimenNum
                            j.price = j.unitPrice
                        })
                        i.originalPrice = i.totalMoney
                    })
                    this.currentIndex++
                    window.scrollTo(0, 0)
                }
                return false
            }
            if (this.currentIndex == 2 && this.isAddOrder === false) {
                this.$refs.mail.backInfo()
                if (!this.mailValid) {
                    return this.$message.error('有必填项（带*为必填项）未完成填写或未规范填写，请规范填写所有必填项')
                }
                this.isAddOrder = true
                //实验要求
                //是否加急
                if (this.mailInfo.ifUrgent === 1) {
                    this.mailBuffet.subChargeVOList[0].buffValue = '是'
                    this.mailBuffet.subChargeVOList[0].totalPrice = Number(this.form.originalPrice) * 0.5
                } else {
                    this.mailBuffet.subChargeVOList[0].buffValue = '否'
                    this.mailBuffet.subChargeVOList[0].totalPrice = 0
                }
                //邮费
                if (this.mailInfo.postMethod == 1) {
                    if (this.mailInfo.postPayment === 2) {
                        this.mailBuffet.subChargeVOList[2].buffValue = '自付运费'
                        this.mailBuffet.subChargeVOList[2].totalPrice = 0
                    } else {
                        this.mailBuffet.subChargeVOList[2].buffValue = '运费到付'
                        this.mailBuffet.subChargeVOList[2].totalPrice = 12
                    }
                } else {
                    this.mailBuffet.subChargeVOList[2].buffValue = this.mailInfo.postMethod === 2 ? '上门取样' : '自己送样'
                    this.mailBuffet.subChargeVOList[2].totalPrice = 0
                }
                //是否回收
                if (this.mailInfo.ifRecycle === 1) {
                    this.mailBuffet.subChargeVOList[1].buffValue = '是'
                    this.mailBuffet.subChargeVOList[1].totalPrice = this.mailInfo.addressId == 298 ? 12 : 50
                    if (this.userInfo.whiteFlag === 1 && this.userInfo.recoveryFree === 1) {
                        this.mailBuffet.subChargeVOList[1].buffValue = '客户优惠'
                        this.mailBuffet.subChargeVOList[1].totalPrice = 0
                    }
                } else {
                    this.mailBuffet.subChargeVOList[1].buffValue = '否'
                    this.mailBuffet.subChargeVOList[1].totalPrice = 0
                }
                // this.buffetList[2] = this.mailBuffet
                const index_ = this.buffetList.findIndex(i => i.sampleName == '实验需求')
                if(index_ < 0) {
                    this.buffetList.push(this.mailBuffet)
                } else {
                    this.buffetList[index_] = this.mailBuffet
                }

                let obj = {
                    ...this.appointForm,
                    ...this.mailInfo,
                    ...this.form,
                    orderType: this.dataForm.isCloudScene,
                    equipmentId: this.dataForm.id,
                    status: 1,
                    expenseDetailList: this.buffetList,
                    activityId: this.isTeamShop ? this.dataForm.groupBuyActivityId : undefined // 如果是团购订单则添加activityId ，不是则不添加
                }
                //如果是白名单客户需要清除收货地址
                if (obj.postMethod === '2') {
                    obj.addressId = undefined
                }
                equipmentSubscribeAdd(obj).then((res) => {
                    this.currentIndex++
                    window.scrollTo(0, 0)
                    this.form.subscribeId = res.data
                    this.$nextTick(() => {
                        this.$refs.pay.init(obj)
                    })
                })
            }
        },
        getMailInfo(info, valid) {
            this.mailInfo = info
            this.mailValid = valid
            const originalPrice = this.form.originalPrice
            let expeditedProduction = 0
            let freightCollected = 0
            let sampleRecovery = 0
            //加急费用
            if (info.ifUrgent == 1) {
                expeditedProduction = (Number(this.form.originalPrice) * 0.5).toFixed(2)
                this.mailBuffet.subChargeVOList[0].buffValue = '是'
                this.mailBuffet.subChargeVOList[0].totalPrice = Number(this.form.originalPrice) * 0.5
            } else {
                this.mailBuffet.subChargeVOList[0].buffValue = '否'
                this.mailBuffet.subChargeVOList[0].totalPrice = 0
            }
            //回收
            if (info.ifRecycle == 1) {
                sampleRecovery = this.mailInfo.addressId == 298 ? 12 : 50
                this.mailBuffet.subChargeVOList[1].buffValue = '是'
                this.mailBuffet.subChargeVOList[1].totalPrice = this.mailInfo.addressId == 298 ? 12 : 50
                if (this.userInfo.whiteFlag === 1 && this.userInfo.recoveryFree === 1) {
                    sampleRecovery = 0
                    this.mailBuffet.subChargeVOList[1].buffValue = '客户优惠'
                    this.mailBuffet.subChargeVOList[1].totalPrice = 0
                }
            } else {
                this.mailBuffet.subChargeVOList[1].buffValue = '否'
                this.mailBuffet.subChargeVOList[1].totalPrice = 0
            }
            //运费
            if (info.postMethod == 1) {
                if (info.postPayment === 2) {
                    this.mailBuffet.subChargeVOList[2].buffValue = '自付运费'
                    this.mailBuffet.subChargeVOList[2].totalPrice = 0
                } else {
                    freightCollected = this.currentIndex == 2 ? 12 : '0.00'
                    this.mailBuffet.subChargeVOList[2].buffValue = '运费到付'
                    this.mailBuffet.subChargeVOList[2].totalPrice = 12
                }
            } else {
                this.mailBuffet.subChargeVOList[2].buffValue = info.postMethod === 2 ? '上门取样' : '自己送样'
                this.mailBuffet.subChargeVOList[2].totalPrice = 0
            }
            this.form.totalCost = (Number(originalPrice) + Number(expeditedProduction) + Number(freightCollected) + Number(sampleRecovery)).toFixed(2)
            // this.buffetList[2] = this.mailBuffet
            const index_ = this.buffetList.findIndex(i => i.sampleName == '实验需求')
            if(index_ < 0) {
                this.buffetList.push(this.mailBuffet)
            } else {
                this.buffetList[index_] = this.mailBuffet
            }
        },
        updateDetectionTotal(info) {
            const showBargaining = []
            // unitPrice单价 totalPrice根据不同计算方式的字段金额
            this.appointForm = { ...info }
            if (info.groups.length > 0) {
                this.buffetList = info.groups.map((i) => {
                    const totalList = []
                    i.fieIdList.map((fie) => {
                        fie.sampleName = i.sampleName
                    })
                    let fieIdList = i.fieIdList.filter((j) => {
                        // 单选、多选、元素周期表要计算价格
                        return (j.fieIdType == 1 || j.fieIdType == 2 || (j.fieIdType == 10 && j.fieIdValue != '')) && j.hide === false
                    })
                    fieIdList.map((k) => {
                        //元素周期表情况
                        if (k.fieIdType == 10) {
                            totalList.push({ ...k })
                        }
                        // 单选、多选情况/根据valueId选择的选项id找到对应选项
                        // if (k.valueId) {
                        //   k.options.map(m => {
                        //     k.valueId.map(n => {
                        //       if (m.optionId == n) {
                        //         totalList.push({
                        //           ...m,
                        //           fieIdName: k.fieIdName,
                        //           calculateWay: k.calculateWay,
                        //           bargainReminder: k.bargainReminder,
                        //           fieIdType: k.fieIdType
                        //         })
                        //       }
                        //     })
                        //   })
                        // }
                    })
                    var map = {},
                        dest = []
                    totalList.map((total) => {
                        // 单选、多选金额
                        if (total.fieIdType == 1 || total.fieIdType == 2) {
                            // 根据价格计算方式处理字段(calculateWay)价格
                            // 1 按样品数量 2 按预约时长 3 固定价格 4 不计算价格(3,4无需计算，2只有云设备需要) 5 待议价
                            if (total.calculateWay == 1) {
                                total.totalPrice = Number(total.unitPrice) * Number(i.specimenNum)
                            } else if (total.calculateWay == 2 && this.dataForm.isCloudScene == 1) {
                                //根据是否使用日历区分
                                if (this.dataForm.isEnableCalendar == 0) {
                                    total.appointHours = Number(this.form.duration)
                                    total.totalPrice = Number(total.unitPrice) * Number(this.form.duration)
                                } else {
                                    if (this.form.appointmentStartDate && this.form.appointmentStartDate != '') {
                                        let obj = this.getDateDiff(this.form.appointmentStartDate, this.form.appointmentEndDate, 'minute')
                                        total.appointHours = obj.hours + obj.min / 60
                                        total.totalPrice = Number(obj.hours) * Number(total.unitPrice) + Number(obj.min / 60) * Number(total.unitPrice)
                                    }
                                }
                            } else if (total.calculateWay == 4) {
                                total.unitPrice = 0
                                total.totalPrice = 0
                            }
                            // 如果有待议价的字段，合计需要显示待议价提示
                            else if (total.calculateWay == 5) {
                                showBargaining.push(total)
                            } else {
                                total.totalPrice = total.unitPrice
                            }
                        } else {
                            // 元素周期表金额
                            if (total.fieIdValue != '') {
                                let list = total.fieIdValue.split(',')
                                total.unitPrice = Number(total.elementPrice) * Number(list.length)
                                total.totalPrice = total.unitPrice * Number(i.specimenNum)
                            }
                        }
                        //字段多选时合并金额
                        if (!map[total.fieIdId]) {
                            dest.push(total)
                            map[total.fieIdId] = total
                        } else {
                            dest.map((j) => {
                                if (total.fieIdId == j.fieIdId) {
                                    j.unitPrice = Number(j.unitPrice) + Number(total.unitPrice)
                                    j.totalPrice = Number(j.totalPrice) + Number(total.totalPrice)
                                }
                            })
                        }
                    })
                    //计算单个样品的总金额
                    i.totalMomey = this.getTotalMoney(dest, 'totalPrice')
                    return { ...i, subChargeVOList: dest }
                })
                this.showBargaining = showBargaining
                //计算所有样品的总金额
                this.form.originalPrice = this.getTotalMoney(this.buffetList, 'totalMomey').toFixed(2)
                this.form.showBargaining = showBargaining
                this.$forceUpdate()
            }
        },
        changeWayActive(item) {
            this.form.photographyMethod = item.index
        },
        changeMagnetismActive(item) {
            this.form.isMagnetism = item.index
        },
        selectAppointTime() {
            this.calendarVisible = true
            this.$nextTick(() => {
                this.$refs.calendar.init(this.dataForm)
            })
        },
        handleScroll(e) {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
            const clientHeight = document.documentElement.clientHeight || window.innerHeight
            if (scrollHeight - (scrollTop + clientHeight) > 347) {
                this.positionBottom = '0px'
            }
            if (scrollHeight - (scrollTop + clientHeight) < 347) {
                this.positionBottom = 347 - (scrollHeight - (scrollTop + clientHeight)) + 'px'
            }
        },
        detailsHandle(i) {
            this.$router.push({
                path: '/equipDetails',
                query: {
                    id: this.$route.query.id,
                    type: this.$route.query.type ? this.$route.query.type : 0
                }
            })
        },
        // 更新基础字段是否校验与显示
        updateBaseFieldValuesNull(value) {
            this.baseFieldValuesNull = value
        },
        //更新实验留言和备注
        updateDesc(descData) {
            this.form.message = descData.message
            this.form.customRemark = descData.customRemark
        }
    }
}
</script>
<style>
#noticeDialog .el-dialog__header {
    background: url('../../assets/img/noticeBg.png') no-repeat;
    background-size: 100% 100%;
    padding: 15px;
}
#noticeDialog .el-dialog__title {
    color: #fff;
}
</style>
<style scoped lang="scss">
.appoint_name {
    font-weight: 500;
    color: #333;
    font-size: 26px;
    margin-bottom: 20px;
    margin-top: 20px;
}
.details_box-card {
    margin-bottom: 30px;
}
.details_img_box {
    border-radius: 8px;
    width: 300px;
    background: #fff;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 15px;
}
.right_details_img {
    width: 220px;
    height: 220px;
    border-radius: 13px;
    margin: 20px auto;
}
.testingInstructions {
    max-height: 300px;
    overflow: hidden;
    overflow-y: scroll;
}
.clearfix {
    position: relative;
}
.isShow {
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: -5px;
    font-size: 26px;
}
.buffet-total-box {
    position: fixed;
    z-index: 2000;
    left: 0;
    width: 100%;
    background: transparent;
    transition: all 0.05s linear;
}
.buffet-total {
    position: relative;
    width: 80%;
    margin: 0 auto;
    background: transparent;
    // div {
    //   width: 100%;
    //   background: #fff;
    //   box-shadow: 0 -3px 6px 0px rgba(0,0,0,0.08)
    // }
    .b_price_detail {
        float: left;
        display: flex;
        align-items: center;
        min-height: 68px;
        font-size: 16px;
        padding-left: 20px;
        border-left: 6px solid #4d6ffe;
        border-radius: 4px;
    }
}
.clearfloat {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #fff;
    box-shadow: 0 -3px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    // padding: 0 20px;
}
.buffet-section {
    line-height: 25px;
    background: #fff;
    margin-bottom: 10px;
}
.showDetail {
    padding-left: 20px;
    cursor: pointer;
    font-size: 16px;
    color: #4d6ffe;
}
.showDetail:hover {
    color: #409eff;
}
.calendarBox {
    position: relative;
    cursor: pointer;
    width: 300px;
    border: 1px solid #dcdfe6;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    color: #666;
    padding-left: 7px;
}
.calendarIcon {
    position: absolute;
    right: 10px;
    font-size: 20px;
}
</style>
